import React, { useEffect, useState } from 'react';
import styles from './AuditionsSection.module.css';
import SectionHeader from '../../../../components/common/SectionHeader/SectionHeader';
import AuditionCardsGrid from './AuditionCardsGrid';
import { AUDITIONS_DATA } from '../../../../constants/landing';
import { getCastingList } from '../../../../api/castingApi';
import { formatCastingDDay, isDeadlineClosing, isDeadlineExpired } from '../../../../utils/castingDeadline';

const DUMMY_AUDITIONS = AUDITIONS_DATA.auditions;

/**
 * @component AuditionsSection
 * @description 진행 중인 공고 섹션 — 최신 공개 공고 3개 실시간 노출, 없으면 더미 표시
 */
function AuditionsSection({ onCardClick }) {
  const { header } = AUDITIONS_DATA;
  const [auditions, setAuditions] = useState(DUMMY_AUDITIONS);

  useEffect(() => {
    const mapItems = (items, isClosed) =>
      items.slice(0, 3).map(item => ({
        id: item.id,
        category: item.category || item.projectType || '기타',
        location: item.regionProvince || item.location || '',
        dDay: isClosed
          ? null
          : formatCastingDDay(item.applicationDeadline, { todayLabel: 'D-Day' }),
        title: item.title,
        company: item.companyName || item.producerName || '',
        roles: (item.roles || []).map(r => r.roleName).filter(Boolean),
        isClosing: isClosed ? false : isDeadlineClosing(item.applicationDeadline),
      }));

    getCastingList({ status: 'OPEN', orderBy: 'latest', perpage: 3, callpage: 1 })
      .then(res => {
        const items = (Array.isArray(res) ? res : (res?.content ?? []))
          .filter(item => !item.applicationDeadline || !isDeadlineExpired(item.applicationDeadline));
        if (items.length > 0) {
          setAuditions(mapItems(items, false));
          return;
        }
        // 진행 중인 공고 없으면 최근 마감 공고로
        return getCastingList({ status: 'CLOSED', orderBy: 'latest', perpage: 3, callpage: 1 })
          .then(res2 => {
            const closed = Array.isArray(res2) ? res2 : (res2?.content ?? []);
            if (closed.length > 0) setAuditions(mapItems(closed, true));
          });
      })
      .catch(() => {});
  }, []);

  return (
    <section className={styles.auditionsSection}>
      <div className={styles.container}>
        <SectionHeader
          title={header.title}
          subtitle={header.subtitle}
          align="left"
          layout="split"
        />
        <AuditionCardsGrid auditions={auditions} onCardClick={onCardClick} />
      </div>
    </section>
  );
}

export default AuditionsSection;
